<template lang="pug">
	#find-us
		h2.section-title Encontre-nos
		.content
			iframe(
				src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3985.989946095498!2d-44.24527198462919!3d-2.5101691981708876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7f691f8cae73935%3A0x69c0405ed1d6fb7d!2sRevisa+Car+Service!5e0!3m2!1spt-BR!2sbr!4v1541501399103",
				width="100%",
				height="600",
				frameborder="0",
				style="border:0",
				allowfullscreen
				)
</template>

<script>

export default {
	name: 'FindUs'
}
</script>

<style lang="stylus" scoped>
@import '../assets/css/resources'

#find-us
	float left
	width 100%
	display flex
	flex-direction column
	background-color white

	.content
		width 100%
		flex 1
		display flex
		flex-direction column
		justify-content center
		margin 50px 0 0
</style>



// WEBPACK FOOTER //
// src/components/FindUs.vue